import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../../helpers/ProjectList";
import "../../styles/ProjectDisplay.css";
import "../../styles/projects/RedBagOld.css";
import Slider from "../../components/Slider";
import { RBoldImg } from "../../helpers/SliderImages";

function RedBagOld() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top when component mounts
  }, []);
  const { id } = useParams();
  const project = ProjectList[1];
  return (
    <div className="project">
      <div className="project-title">
        <h1 style={{ color: "#a2d2ff" }}> {project.name}</h1>
      </div>
      <Slider mediaArray={RBoldImg} />
      <div className="projectContent">
        <p>
          <b>Skills:</b> {project.skills}
        </p>
        <p>
          <b>Overview:</b> {project.overview}
        </p>
      </div>
    </div>
  );
}

export default RedBagOld;
